import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/white-logo.svg'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { style: {"max-width":"550px"} }
const _hoisted_3 = { class: "card bg-white border-0 rounded-10 mb-4 text-center" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "fs-20 fw-semibold mb-2" }
const _hoisted_6 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mb-3 mb-md-4" }, [
              _createElementVNode("img", {
                src: "/favicon-32x32.png",
                class: "rounded-3 for-light-logo",
                alt: "login"
              })
            ], -1 /* HOISTED */)),
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_0,
              class: "rounded-3 for-dark-logo",
              alt: "login"
            }, null, -1 /* HOISTED */)),
            _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.isSuccess?"Éxito":"Error") + " !", 1 /* TEXT */),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.message), 1 /* TEXT */),
            _createVNode(_component_RouterLink, {
              to: "/login",
              class: "btn btn-primary fs-16 fw-medium text-dark py-2 px-4 text-white w-100"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" Ir Login ")
              ])),
              _: 1 /* STABLE */
            })
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}